import { compact, isEmpty, find, size } from 'lodash'
import ChartConfigurations from '@/components/list-view-visualisation/chart/ChartConfigurations'

export default {
  methods: {
    isCategorySelectorVisible(routeName) {
      return find(ChartConfigurations, (config) => config.name === routeName).showCategoryOptions
    },
    isMeasureSingleSelectorVisible(routeName) {
      return find(ChartConfigurations, (config) => config.name === routeName)
        .showSingleMeasureOptions
    },
    isMeasureMultiSelectorVisible(routeName) {
      return find(ChartConfigurations, (config) => config.name === routeName)
        .showMultiMeasureOptions
    },
    isTitleInputVisible(routeName) {
      return find(ChartConfigurations, (config) => config.name === routeName).showTitleInput
    },
    isGeoSelectorVisible(routeName) {
      return (
        size(this.geoCategories) > 1 &&
        find(ChartConfigurations, (config) => config.name === routeName).showGeoOptions
      )
    },
    containsSelectableGeoCategories() {
      return !(
        size(this.geoCategories) === 2 &&
        !isEmpty(this.defaultLatitude) &&
        !isEmpty(this.defaultLongitude)
      )
    },
    isSeriesSelectorVisible(routeName) {
      return (
        compact(this.measures).length === 1 &&
        compact(this.calculatedMeasures).length === 0 &&
        find(ChartConfigurations, (config) => config.name === routeName).showSeries
      )
    },
    isLocationSelectorVisible() {
      return isEmpty(this.defaultLocation)
    },
    isWordCloudKeywordSelectorVisible(routeName, wordCloudColumns) {
      return (
        find(ChartConfigurations, (config) => config.name === routeName)
          .showWordCloudKeywordSelector && wordCloudColumns.length
      )
    },
  },
}
